module.exports = __webpack_public_path__ + "img/22.9baa6836.png";